import React, { useRef } from "react";
import "../styles/EnrollSection/EnrollSection.css";

const EnrollmentForm = () => {
  const formRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(formRef.current);
    formData.append("form_type", "Global Professional Courses Application");

    try {
      const response = await fetch(
        "https://formsubmit.co/ajax/admission@madhiacademy.com",
        {
          method: "POST",
          headers: { Accept: "application/json" },
          body: formData,
        }
      );

      if (response.ok) {
        alert("Application submitted successfully!");
        formRef.current.reset();
      } else {
        alert("Submission failed. Please try again.");
      }
    } catch (error) {
      alert("Network error. Please try later.");
    }
  };

  return (
    <div className="enrollment-page-wrapper">
      {/* Header */}
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-7 col-md-9">
            <h2 className="fw-bold mb-3 text-purple-header">
              Apply to Global Professional Courses
            </h2>
            <p className="text-secondary small mb-0">
              For international learners and global certifications.
            </p>
          </div>
        </div>
      </div>

      {/* Form Section */}
      <section className="enrollment-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-9 col-sm-12">

              <form ref={formRef} onSubmit={handleSubmit}>
                
                {/* Full Name */}
                <div className="mb-4">
                  <label className="form-label custom-label">
                    Full Name <span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    name="full_name"
                    className="form-control custom-input"
                    required
                  />
                </div>

                {/* Email */}
                <div className="mb-4">
                  <label className="form-label custom-label">
                    Email ID <span className="required-star">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    className="form-control custom-input"
                    required
                  />
                </div>

                {/* Country */}
                <div className="mb-4">
                  <label className="form-label custom-label">
                    Country of Residence <span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    name="country"
                    className="form-control custom-input"
                    required
                  />
                </div>

                {/* Program */}
                <div className="mb-4">
                  <label className="form-label custom-label mb-2">
                    Program <span className="required-star">*</span>
                  </label>

                  {["US CPA", "US CMA", "EA"].map((program, i) => (
                    <div className="form-check custom-radio mb-2" key={i}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="program"
                        value={program}
                        required
                      />
                      <label className="form-check-label custom-label">
                        {program}
                      </label>
                    </div>
                  ))}
                </div>

                {/* Notes */}
                <div className="mb-4">
                  <label className="form-label custom-label">Notes</label>
                  <textarea
                    name="notes"
                    className="form-control custom-input"
                    rows="3"
                    placeholder="Type your message here..."
                  ></textarea>
                </div>

                {/* Consent */}
                <div className="mb-4 form-check">
                  <input
                    type="checkbox"
                    name="consent"
                    value="Agreed"
                    className="form-check-input"
                    required
                  />
                  <label className="form-check-label custom-label small">
                    I consent to be contacted and to cross-border data processing.
                  </label>
                </div>

                {/* FormSubmit Settings */}
                <input
                  type="hidden"
                  name="_subject"
                  value="Global Professional Course Application - Madhi Academy"
                />
                <input type="hidden" name="_captcha" value="false" />
                <input type="hidden" name="_template" value="table" />

                {/* Submit */}
                <div className="mb-5">
                  <button type="submit" className="btn custom-btn-outline">
                    Submit Application
                  </button>
                </div>
              </form>

              {/* Privacy */}
<div className="privacy-line">
  Privacy: Your data is used only for enrollment communication.
  <span className="separator">&nbsp;|&nbsp;</span> 
  Support:{" "}
  <a href="mailto:support@madhiacademy.com" className="privacy-link">
    support@madhiacademy.com
  </a>
  <span className="separator">&nbsp;|&nbsp;</span> 
  Contact with Us: 7708941960
</div>

            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EnrollmentForm;
